import React from "react";
import { FaCommentDollar } from "react-icons/fa";



export default function MoneyInteractive() {
    return (
        <div className="speed-interactive-container">
          <div className="speed-interactive-icon" style={{background: 'none', paddingTop:'0px', marginTop:'-5px'}}><FaCommentDollar size={62} fill="#007A33" /></div>
        </div>
    );
}